/* Osmanlı Doğal Taş — Tesbih Tasarlayıcı · PANEL İZLEME
   Huni: giris → tasarim → sepet   (sipariş sonradan kodla eşleşir)

   İLKELER
   · EDİLGEN: tasarımcının durumunu DEĞİŞTİRMEZ, yalnız `ODTTesbihOzet()`
     salt-okunur özetini okur. Hiçbir olayı engellemez.
   · (oturum, olay) sunucuda TEKİL — sayfayı tazelemek sayıyı şişirmez.
   · Hata hâlinde sessiz: ölçüm çökse bile tasarımcı çalışmaya devam eder.
*/
(function (g, d) {
  "use strict";
  var API = "https://www.osmanliyonetim.com/wp-json/odt/v1/tesbih/olay";

  /* Yalnız tasarımcı sayfasında */
  if (!/\/pages\/tesbih-tasarla\/?$/.test((g.location.pathname || "").replace(/\/+$/, "/"))) {
    if ((g.location.pathname || "").indexOf("tesbih-tasarla") < 0) return;
  }

  var oturum = "";
  try {
    oturum = g.sessionStorage.getItem("odtTesbihOturum") || "";
    if (!oturum) {
      oturum = (Date.now().toString(36) + Math.random().toString(36).slice(2, 12)).replace(/[^a-z0-9]/g, "").slice(0, 32);
      g.sessionStorage.setItem("odtTesbihOturum", oturum);
    }
  } catch (e) {}
  if (!oturum) oturum = (Date.now().toString(36) + Math.random().toString(36).slice(2, 12)).slice(0, 32);

  var yollandi = {};

  function cihaz() {
    try { return g.matchMedia("(max-width: 767px)").matches ? "mobil" : "masaustu"; }
    catch (e) { return ""; }
  }

  function gonder(olay) {
    if (yollandi[olay]) return;
    yollandi[olay] = 1;
    var govde = { oturum: oturum, olay: olay, cihaz: cihaz() };
    try {
      var o = g.ODTTesbihOzet ? g.ODTTesbihOzet() : null;
      if (o) {
        govde.kod = o.kod; govde.niyet = o.niyet; govde.puskul = o.puskul;
        govde.mm = o.mm; govde.boy = o.boy; govde.taslar = o.taslar;
        govde.harfler = o.harfler; govde.fiyat = o.fiyat;
      }
    } catch (e) {}
    try {
      /* sendBeacon KULLANILMIYOR: application/json gövdesi CORS ön-kontrol
         gerektirir, beacon ön-kontrol yapamaz ve istek sessizce düşer.
         (Aynı tuzağa odt-olcum.js'te de düşülmüştü.) */
      g.fetch(API, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(govde), keepalive: true, mode: "cors"
      }).catch(function () {});
    } catch (e) {}
  }

  /* Dışarıdan çağrılabilir: tasarımcı sepete ekleme BAŞARILI olunca çağırır. */
  g.ODTTesbihIzle = function (olay) {
    if (olay === "sepet" || olay === "tasarim" || olay === "giris") gonder(olay);
  };

  function basla() {
    gonder("giris");
    /* 5. adım = taş seçme ekranı. Tasarımcı adımı kendi durumunda tutuyor;
       DOM'a bakmak yerine oradan okunuyor (görünürlük kuralları değişebilir). */
    var kalan = 900;                       /* ~7,5 dk */
    var t = setInterval(function () {
      var o = null;
      try { o = g.ODTTesbihOzet ? g.ODTTesbihOzet() : null; } catch (e) {}
      if (o && o.adim >= 5) { gonder("tasarim"); clearInterval(t); return; }
      if (--kalan <= 0) clearInterval(t);
    }, 500);
  }

  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", basla);
  else basla();
})(window, document);
